import { Form } from "@renderbus/ui";
import { FormInstance } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Input } from "@renderbus/ui";
import styled from "styled-components";
import { useValidatorChinese } from "../../../hooks/useValidator";

export function VerificationImportForm({
  form,
  handleCheckValidator,
}: {
  form: FormInstance;
  handleCheckValidator: (value: boolean) => void;
}) {
  const t = getTranslateNsT("childManager");
  const { enterpriseAliasValidator } = useValidatorChinese();
  return (
    <>
      <div className="integration-item-title">
        {t("dingtalk_subaccount_create_text5")}&nbsp;
      </div>
      <Form
        size={"large"}
        form={form}
        layout="vertical"
        className="verification-form"
        style={{ width: 560, margin: "auto" }}
      >
        <Form.Item
          name="enterpriseAlias"
          validateTrigger="onBlur"
          label={t("dingtalk_subaccount_setting_enterprise_name")}
          rules={[
            {
              validator: () =>
                enterpriseAliasValidator(form.getFieldValue("enterpriseAlias")),
            },
          ]}
        >
          <Input
            className="background-2C2C31"
            onBlur={() => {
              form.validateFields().then(
                () => {
                  return handleCheckValidator(true);
                },
                () => {
                  return handleCheckValidator(false);
                }
              );
            }}
          />
        </Form.Item>
      </Form>
      <VerificationRulesContainer>
        <span>{t("dingtalk_subaccount_setting_name_rules1")}</span>
        <span>{t("dingtalk_subaccount_setting_name_rules2")}</span>
        <span>{t("dingtalk_subaccount_setting_name_rules3")}</span>
      </VerificationRulesContainer>
    </>
  );
}

const VerificationRulesContainer = styled.div`
  color: rgba(151, 160, 161, 1);
  line-height: 20px;
  font-size: 12px;
  margin: 6px auto 32px;
  width: 560px;
  text-align: left;
  span {
    position: relative;
    padding-right: 26px;
    &::after {
      position: absolute;
      content: "";
      width: 1px;
      top: 4px;
      height: 10px;
      right: 13px;
      background: rgba(74, 82, 86, 1);
    }
  }
  span:last-child {
    padding-right: 0;
    &:after {
      display: none;
    }
  }
`;
